import React from 'react';
import { useState } from 'react'; // Removed the unused 'React' import
import MainContent from '../components/adminpanel/MainContent';
import Sidebar from '../components/adminpanel/Sidebar';

function AdminPanel() {
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const handleMenuClick = (id: string) => {
    setActiveItem(id);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar onMenuClick={handleMenuClick} />
      <MainContent activeItem={activeItem} />
    </div>
  );
}

export default AdminPanel;
